import React from 'react';
import Card from './Card';

function ActivityItem({ a }) {
  return (
    <div className="flex items-start justify-between py-3 border-b last:border-b-0">
      <div>
        <div className="font-medium">{a.title}</div>
        <div className="text-sm text-gray-500">{a.subtitle}</div>
      </div>
      <div className="text-sm text-gray-400">{a.time}</div>
    </div>
  );
}

export default function ActivityList({ activities = [] }) {
  return (
    <Card>
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-medium">Atividade recente</h3>
        <button className="text-sm text-purple-600">Ver todas</button>
      </div>

      <div>
        {activities.map((a) => (
          <ActivityItem key={a.id} a={a} />
        ))}
      </div>
    </Card>
  );
}
